export default __webpack_public_path__ + "static/blue-car-d0afed4d7a5a6eb5f2a0a8f2792ba790.png";